export default columnWidths => {
  return columnWidths.map(col => `${col}fr`).join(' ')
}